import { IComponentOptions } from "angular";
import { ContractPatchBulkController } from "./controller";

export const vsComponentName = "contractPatchBulk";

export const contractPatchBulkComponentOptions: IComponentOptions =
  {
    controller: ContractPatchBulkController,
    template: require("!html-loader!./index.html").default,
    controllerAs: "stateController",
    bindings: {
      contractIds: "<",
      contracts: "<"
    },
  };
